import React, { Component } from 'react';
import { Form, Image, Button, InputGroup } from 'react-bootstrap';
import * as queryString from 'query-string';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  IResetPasswordState,
  IResetPasswordProps,
  ILinkVerificationData,
  IRootState,
  IResetPasswordData,
} from '../../interfaces';
import { resetPasswordValidator } from '../../helper/validator';
import { LinkVerificationRequest, ResetPasswordRequest } from '../../action';
import mailIcon from '../../assets/images/auth/mail.png';
import logo from '../../assets/images/logo.png';
import logoImg from "./../../assets/images/fail-ic.svg";
import PasswordMessage from '../Dashboard/PasswordMessage';
import { any } from 'prop-types';
class ResetPassword extends Component<
  IResetPasswordProps,
  IResetPasswordState
  > {
  constructor(props: any) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      verifyToken: '',
      email: '',
      id: '',
      errors: {
        password: '',
        confirmPassword: '',
      },
      isSucessfullySubmitted: false,
      showPopup: true,
      validBar: '',
    };
  }
  componentDidMount = () => {
    const parsed = queryString.parse(this.props.location.search);
    var divStr = "";
    var divParentBar = document.getElementById("validBar");
    let divChild : any;
    let borderRadius = "";
    for(var i=1;i<=5;i++){
       divChild = document.createElement("div");
       if(i===1) {
        borderRadius = "border-Top-Left-Radius:20px;border-Bottom-Left-Radius:20px";
       } else if(i===5){
        borderRadius = "border-Top-Right-Radius:20px;border-Bottom-Right-Radius:20px";
       } else {
        borderRadius = "";
       }
       divChild.setAttribute("style","width:4rem;height:10px;background-Color:red;float:left;padding-bottom:10px;"+borderRadius);     
       divParentBar?.appendChild(divChild);
    }
   
    if (parsed) {
      const data = {
        user: (parsed.user as string) || '',
        token: (parsed.token as string) || '',
        verification: (parsed.verification as string) || '',
      };
      this.props.linkVerification(data);
    }
  };
  componentDidUpdate = (prevProps: IResetPasswordProps) => {
    const { linkVerificationData, resetPasswordReducer } = this.props;
    const { isVerified } = linkVerificationData;
    const { isError, isLoading } = resetPasswordReducer;
    if (isVerified !== prevProps.linkVerificationData.isVerified) {
      const { verificationData } = linkVerificationData;
      const { verifyToken, email, id } = verificationData;
      this.setState({
        verifyToken,
        email,
        id,
      });
    }
    if (isLoading !== prevProps.resetPasswordReducer.isLoading) {
      this.setState({
        isSucessfullySubmitted: !isError,
      });
    }
  };
  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if(name === 'password') {
      var metValid = 0;
    if(/[A-Z]/.test(value)) {
      metValid = metValid+1;
    } 
    if(/[a-z]/.test(value)) {
      metValid = metValid+1;
    }     
    if(/[0-9]/.test(value)) {
      metValid = metValid+1;
    }
    if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value)) {
      metValid = metValid+1;
    }
    if(value.length >= 8 && value.length <= 10) {
      metValid = metValid+1;
    }
    var divParentBar = document.getElementById("validBar");
    let divChild : any;
    let borderRadius = '';
    for(var i=1;i<=5;i++){
      divChild = document.createElement("div");
      if(i===1) {
        borderRadius = "border-Top-Left-Radius:20px;border-Bottom-Left-Radius:20px";
       } else if(i===5){
        borderRadius = "border-Top-Right-Radius:20px;border-Bottom-Right-Radius:20px";
       } else {
        borderRadius = "";
       }
      if(i<=metValid && i != 0) {
        divChild.setAttribute("style","width:4rem;height:10px;background-Color:green;float:left;padding-bottom:10px;"+borderRadius);     
      } else {
        divChild.setAttribute("style","width:4rem;height:10px;background-Color:red;float:left;padding-bottom:10px;"+borderRadius);     
      }
      if(divParentBar?.children[i-1]) {
        (divParentBar?.children[i-1]).replaceWith(divChild)
      } 
    }
    }
    
    this.setState({
      ...this.state,
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: '',
      },
    });    
  };

  handleAlertClose = () => {
    this.setState({
      showPopup: false,
    });
  };

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { password, confirmPassword } = this.state;
    let data = {
      password,
      confirmPassword,
    };
    // To validate form fields
    const { isValid, errors } = resetPasswordValidator(data);
    if (isValid) {
      const { verifyToken, email, id } = this.state;
      this.props.resetPassword({
        ...data,
        verifyToken,
        email,
        id,
      });
    } else {
      this.setState({
        errors,
      });
      return;
    }
  };
  render() {
    const {
      password,
      confirmPassword,
      errors,
      isSucessfullySubmitted,
    } = this.state;
    const { linkVerificationData } = this.props;
    const { isVerified } = linkVerificationData;
    return (
      <section className='reset-section'>
        <div className='reset-div'>
          <div className={'login-form pb-0'}>
            <div className='reset-logo'>
              <img src={logo} alt='logo' />
            </div>
            {isSucessfullySubmitted ? (
              <div className={'text-center'}>
                <div className='icon--order-success svg py-4'>
                  <svg width='72px' height='72px'>
                    <g fill='none' stroke='#8EC343' strokeWidth='2'>
                      <circle
                        cx='36'
                        cy='36'
                        r='35'
                        className='svg-circle'
                      ></circle>
                      <path d='M17.417,37.778l9.93,9.909l25.444-25.393'></path>
                    </g>
                  </svg>
                </div>
                <p className='reset-text mb-4'>
                  Password updated successfully.
                </p>
              </div>
            ) : (
                <>
                  <h5 className='text-center'>
                    <span>Reset</span> Your Password
                </h5>
                  {isVerified ? (
                    <>
                    {this.state.showPopup ? (
                      <PasswordMessage
                        handleClose={this.handleAlertClose}
                        show='true' />
                    ):"" }
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Group controlId='formBasicEmail'>
                          <InputGroup>
                            <input
                              type={'password'}
                              name={'password'}
                              value={password}
                              className={'form-control form-input'}
                              placeholder=' '
                              onChange={this.handleChange} />
                            <Form.Label
                              className={`login-form-label ${password ? 'top-label' : ''}`}
                            >
                              Password
                            </Form.Label>
                            <span className='login-icon'>
                              <Image src={mailIcon} />
                            </span>
                          </InputGroup>

                          <div className={'text-danger error-field'}>
                            {errors && errors.password}
                          </div>
                        </Form.Group>
                        <Form.Group controlId='formBasicEmail'>
                          <InputGroup>
                            <input
                              type={'password'}
                              name={'confirmPassword'}
                              value={confirmPassword}
                              className={'form-control form-input'}
                              placeholder=' '
                            onChange={this.handleChange}
                          />
                            <Form.Label
                            className={`login-form-label ${
                              confirmPassword ? 'top-label' : ''
                              }`}
                            >
                              Confirm Password
                            </Form.Label>
                            <span className='login-icon'>
                              <Image src={mailIcon} />
                            </span>
                          </InputGroup>

                          <div className={'text-danger error-field'}>
                            {errors && errors.confirmPassword}
                          </div>
                        </Form.Group>
                        <div style={{paddingBottom:"20px"}} id="validBar">
                        </div>
                        <div className='text-center my-4'>
                          <Button type='submit' className='slider-btn'>
                            Submit
                          </Button>
                        </div>
                        <div className='divider text-center mb-2'>
                          <span>OR</span>
                        </div>
                        <p className='text-center'>
                          Remember your password?{' '}
                          <span className='forget-link'>Sign In</span>
                        </p>
                      </Form></>
                  ) : (
                      <div className={'text-center'}>
                        <div className='icon--order-success svg py-4'>
                          <img
                            src={logoImg}
                            alt=""
                          />
                        </div>
                        <p className='expire-text mb-4 mandatory'>
                          Your reset password link is invalid or has been expired.
                    </p>
                      </div>

                      // <h6 className='text-center mandatory'></h6>
                    )}
                </>
              )}
          </div>
          <div className='text-center'>
            <span
              className='btn btn-submit'
              onClick={() => this.props.history.push('/')}
            >
              Back to home
            </span>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state: IRootState) => ({
  linkVerificationData: state.linkVerificationReducer,
  resetPasswordReducer: state.resetPasswordReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    linkVerification: (data: ILinkVerificationData) => {
      dispatch(LinkVerificationRequest(data));
    },
    resetPassword: (data: IResetPasswordData) => {
      dispatch(ResetPasswordRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
